import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { GuestTaskMigrationService } from '../guest-task-migration-service';
import { GuestTaskApi } from '../../apis/guest-task-api';

/**
 * 游客任务迁移服务实现
 */
@injectable()
export class GuestTaskMigrationServiceImpl implements GuestTaskMigrationService {
    constructor(
        @inject(GuestTaskApi)
        private readonly _guestTaskApi: GuestTaskApi,
    ) {}

    async migrateTasksToUser(): Promise<void> {
        await this._guestTaskApi.refreshGuestTasks();
    }
}
